<template>
  <v-app id="reset">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container fluid class="text-center">
                  <img src="@/assets/logo.png" height="250" width="auto"/>
                  <!--<div class="display-1 font-weight-bold mt-2 primary--text"></div>-->
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">Reestablecer contraseña</v-card-title>
                    <v-card-text>
                      <v-text-field v-model="password" type="password" :disabled="flag || loading" prepend-icon="mdi-lock" required
                      label="Nueva contraseña" @input="$v.password.$touch()" @blur="$v.password.$touch()">
                      </v-text-field>
                      <v-text-field v-model="password2" type="password" :disabled="flag || loading" prepend-icon="mdi-lock" required
                      label="Repetir contraseña" @input="$v.password2.$touch()" @blur="$v.password2.$touch()">
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="loading" @click="home()">Inicio</v-btn>
                      <v-btn type="submit" text :disabled="flag" :loading="loading">Actualizar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ msgError }}
                </v-snackbar>
                <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                  {{ msgSuccess }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer padless>
      <v-card class="flex" flat tile color="#ffffff">
        <v-card-text class="py-2 text-center">
          {{ new Date().getFullYear() }} — <strong>Censo MKD</strong>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import services from '@/utils/services'

export default {
  name: 'reset',
  mixins: [validationMixin],
  validations: {
    password: {
      required,
      maxLength: maxLength(50)
    },
    password2: {
      required,
      maxLength: maxLength(50)
    }
  },
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    solicitud: '',
    password: '',
    password2: '',
    flag: false
  }),
  mounted() {
    this.solicitud = this.$route.query.id
  },
  computed: {
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('El campo es obligatorio')
      !this.$v.password.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    },
    password2Errors() {
      const errors = []
      if (!this.$v.password2.$dirty) return errors
      !this.$v.password2.required && errors.push('El campo es obligatorio')
      !this.$v.password2.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    }
  },
  methods: {
    clear() {
      this.$v.$reset()
      this.password = ''
      this.password2 = ''
    },
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid && this.password == this.password2 && this.solicitud && this.solicitud !== '') {
        this.reset()
      }
      else if (!this.solicitud || this.solicitud === '') {
        this.error = true
        this.msgError = 'El id de la solicitud es incorrecto'
      }
      else if (!this.$v.$invalid) {
        this.error = true
        this.msgError = 'Las contraseñas no coinciden'
      }
      else {
        this.error = true
        this.msgError = 'Algunos datos del formulario son incorrectos'
      }
    },
    home() {
      this.$router.push('/login')
    },
    reset() {
      this.loading = true
      setTimeout(() => {
        this.axios.post(services.routes.reset, { id: this.solicitud, password: this.password })
          .then(response => {
            let res = response.data
            if (res.correcto) {
              this.clear()
              this.flag = true
              this.success = true
              this.msgSuccess = res.mensaje
            } else {
              this.error = true
              this.msgError = res.mensaje
            }
          })
          .catch(error => {
            console.log(error)
            this.error = true
            this.msgError = 'El servicio no se encuentra disponible en estos momentos'
          })
          .finally(() => {
            this.loading = false
          })
      }, 300)
    }
  }
}
</script>

